import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import http from "../../../../services/http.service";
import { toast } from "react-toastify";
import { apiPageLimit } from "../../../../constants/common";

const LOG_HOUR = `/log-hours`;
const ACCEPT_LOG_HOUR = `/spouse/log-hours`;
const SPOUSE_LOG_HOUR = `/log-hours/spouse/property`;
const UPLOAD_LOG_HOUR_CSV = `/log-hours/upload/csv`;
const REMAINING_HOUR = `/remaining/hours`;


export const getLogHourList = createAsyncThunk(
  "getLogHourList",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { page = 1, limit = apiPageLimit, search = "", main_category = "", status = "", property = "", owner_uuid = "" } = values;
      const response = await http.get(`${LOG_HOUR}?page=${page}&limit=${limit}&search=${search}&main_category=${main_category}&status=${status}&property=${property}&owner_uuid=${owner_uuid}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const logHourRequestLists = createAsyncThunk(
  "logHourRequestLists",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const { role = "spouse", page = 1, limit = apiPageLimit } = values;
      const response = await http.get(`${LOG_HOUR}?role=${role}&page=${page}&limit=${limit}`);
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to archive log hour request");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const acceptRejectLogHour = createAsyncThunk(
  "acceptRejectLogHour",
  async ({ uuid, values }: { uuid: any, values: any }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.put(`${ACCEPT_LOG_HOUR}/${uuid}`, values);
      toast.success(response?.data?.message || "Log hour request updated Successfully.");
      dispatch(logHourRequestLists({}));
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to update log hour request");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const archiveLogHour = createAsyncThunk(
  "archiveLogHour",
  async ({ uuid, archieve }: { uuid: any, archieve: any }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.put(`${LOG_HOUR}/${uuid}`, { archieve });
      toast.success(response?.data?.message || "Log hour archived Successfully.");
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to archive log hour");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const addLogHour = createAsyncThunk(
  "addLogHour",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.post(`${LOG_HOUR}`, values);
      toast.success(response?.data?.message || "Log hour added Successfully.");
      dispatch(getLogHourList({}));
      return response?.data;
    }
    catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to add log hour");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const getSpouseLogHours = createAsyncThunk(
  "getSpouseLogHours",
  async ({ uuid }: { uuid: any }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.get(`${SPOUSE_LOG_HOUR}/${uuid}`);
      return response.data;
    } catch (error: any) {
      // if (error instanceof AxiosError) {
      //   toast.error(error?.response?.data?.error || "Failed to get spouce log hours");
      //   return
      // }
      return rejectWithValue(error.message);
    }
  }
);

export const getLogHourDetails = createAsyncThunk(
  "getLogHourDetails",
  async ({ uuid }: { uuid: any }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.get(`${LOG_HOUR}/${uuid}`);
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to get log hour details");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const deleteLogHourReceipt = createAsyncThunk(
  "deleteLogHourReceipt",
  async ({ uuid, logHoureId }: { uuid: string, logHoureId: string }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.delete(`${LOG_HOUR}/${logHoureId}/image/${uuid}`);
      toast.success(response?.data?.message);
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to delete receipt");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const uploadLogHourCsv = createAsyncThunk(
  "uploadLogHourCsv",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.post(`${UPLOAD_LOG_HOUR_CSV}`, values);
      console.log('response === ', response);

      toast.success(response?.data?.message || "File uploaded successfully.");
      dispatch(getLogHourList({}));
      return response?.data;
    }
    catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to upload file");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const updateLogHour = createAsyncThunk(
  "updateLogHour",
  async ({ uuid, values }: { uuid: any, values: any }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.put(`${LOG_HOUR}/${uuid}`, values);
      toast.success(response?.data?.message || "log hour updated Successfully.");
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to update log hour");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const deleteLogHour = createAsyncThunk(
  "deleteLogHour",
  async ({ uuid }: { uuid: string }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.delete(`${LOG_HOUR}/${uuid}`);
      toast.success(response?.data?.message || "Log hour deleted Successfully.");
      dispatch(getLogHourList({}));
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to delete log hour");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const addLogHourComment = createAsyncThunk(
  "addLogHourComment",
  async ({ uuid, comment }: { uuid: any, comment: any }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.put(`${LOG_HOUR}/comment/${uuid}`, { comment });
      toast.success(response?.data?.message || "Comment added Successfully.");      
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to add comment.");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const getRemainingLogHour = createAsyncThunk(
  "getRemainingLogHour",
  async ({ date }: { date: any }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.get(`${REMAINING_HOUR}?date=${date}`);
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to get remaining log hour.");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);